import { PrimaryMainColor } from 'config';

export const timerThemeColor = '#fd9900';
export const successColor = PrimaryMainColor; // '#038b00';
